/**
 * @file constants/roles.js
 * Costanti dei ruoli utente (corrispondono ai ruoli definiti sul BE).
 * PREDEFINITO è il ruolo di fallback in assenza di sessione valida.
 */

// ruoli backend e frontend

export const ROLES = {
  ADMIN: "Admin",
  PLANNER: "Planner",
  PM_RICHIEDENTE: "PMRichiedente",
  RICHIEDENTE: "Richiedente",
  HR: "HR",
  USER: "User",
  SALES_BACKOFFICE: "SalesBackoffice",
  PREDEFINITO: "Admin",
};
